/*
 * VELTRON 2027 - page "Suivre ma commande" (sections/veltron-tracking.liquid)
 *
 * Suivi reel, rien de simule : le numero saisi ouvre la page officielle du transporteur dans un nouvel onglet
 * (ou 17TRACK quand le transporteur n'est pas reconnu). Rien n'est envoye a la boutique, rien n'est stocke.
 * Adresses de suivi : celles que Shopify enregistre pour les transporteurs deja utilises par la boutique.
 */
(function () {
  'use strict';

  if (window.VtTracking) return;

  function enc(value) {
    return encodeURIComponent(value);
  }

  var CARRIERS = {
    colissimo: { name: 'Colissimo', url: function (n) { return 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + enc(n); } },
    chronopost: { name: 'Chronopost', url: function (n) { return 'https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=' + enc(n); } },
    dhl: { name: 'DHL', url: function (n, d) { return 'https://www.dhl.com/' + (d.dhl || 'de-en') + '/home/tracking.html?submit=1&tracking-id=' + enc(n); } },
    gls: { name: 'GLS', url: function (n) { return 'https://gls-group.eu/FR/fr/suivi-colis?directLink=false&match=' + enc(n); } },
    amazon: { name: 'Amazon Logistics', url: function (n) { return 'https://track.amazon.fr/tracking/' + enc(n); } },
    auto: { name: '17TRACK', url: function (n, d) { return 'https://t.17track.net/' + (d.t17 || 'en') + '#nums=' + enc(n); } }
  };

  /* Formats sans ambiguite, releves sur les expeditions reelles de la boutique (Colissimo, Chronopost, DHL, Amazon) ;
     tout le reste passe par 17TRACK, et le transporteur peut toujours etre choisi a la main */
  var PATTERNS = [
    ['colissimo', /^[0-9][A-Z][0-9]{11}$/],
    ['chronopost', /^[A-Z]{2}[0-9]{9}JB$/],
    ['dhl', /^JJD[0-9A-Z]{10,30}$/],
    ['amazon', /^FR[0-9]{10}$/]
  ];

  /* Les textes du bloc JSON sont ecrits avec des entites HTML (le fichier du theme reste en ASCII) : on les decode ici */
  function decode(text) {
    var box = document.createElement('textarea');
    box.innerHTML = String(text);
    return box.value;
  }

  function readData(root) {
    var node = root.querySelector('[data-vt-track-data]');
    if (!node) return {};
    var data;
    try {
      data = JSON.parse(node.textContent) || {};
    } catch (error) {
      return {};
    }
    ['errEmpty', 'errOrder', 'errFormat', 'status'].forEach(function (key) {
      if (typeof data[key] === 'string') data[key] = decode(data[key]);
    });
    return data;
  }

  /* "6a 0777.1869 850" -> "6A07771869850" ; null si le texte n'a pas la forme d'un numero de suivi */
  function normalize(raw) {
    var value = String(raw || '').replace(/[\s.]+/g, '').toUpperCase();   /* \s couvre aussi l'espace insecable */
    return /^[A-Z0-9-]{5,40}$/.test(value) ? value : null;
  }

  function pickCarrier(choice, number) {
    if (choice && choice !== 'auto' && CARRIERS[choice]) return choice;
    for (var i = 0; i < PATTERNS.length; i += 1) {
      if (PATTERNS[i][1].test(number)) return PATTERNS[i][0];
    }
    return 'auto';
  }

  function trackingUrl(choice, number, data) {
    var id = pickCarrier(choice, number);
    return { id: id, name: CARRIERS[id].name, url: CARRIERS[id].url(number, data || {}) };
  }

  function setError(form, input, message) {
    var box = form.querySelector('.vt-track__error');
    var result = form.querySelector('[data-vt-track-result]');
    if (result) result.hidden = true;
    if (box) {
      box.textContent = message || '';
      box.hidden = !message;
    }
    if (input) {
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function openInNewTab(url) {
    var link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-vt-track-form]')) return;
    event.preventDefault();

    var root = form.closest('[data-vt-track]') || document;
    var data = readData(root);
    var input = form.elements.tracking_number;
    var select = form.elements.carrier;
    var raw = String(input.value || '').trim();

    if (!raw) {
      setError(form, input, data.errEmpty || 'Enter your tracking number.');
      input.focus();
      return;
    }
    if (raw.charAt(0) === '#' || raw.charCodeAt(0) === 0xff03) {   /* # ou son equivalent pleine largeur */
      setError(form, input, data.errOrder || 'This looks like an order number, not a tracking number.');
      input.focus();
      return;
    }
    var number = normalize(raw);
    if (!number) {
      setError(form, input, data.errFormat || 'This number is not valid.');
      input.focus();
      return;
    }

    var target = trackingUrl(select ? select.value : 'auto', number, data);
    setError(form, input, '');

    var result = form.querySelector('[data-vt-track-result]');
    if (result) {
      var status = result.querySelector('.vt-track__status');
      var retry = result.querySelector('.vt-track__retry');
      if (status) status.textContent = String(data.status || '{carrier}').replace('{carrier}', target.name);
      if (retry) retry.href = target.url;
      result.hidden = false;
    }
    openInNewTab(target.url);
  }

  /* Le formulaire est gere au niveau du document : aucune reinitialisation quand l'editeur de theme recharge la section */
  document.addEventListener('submit', onSubmit);
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-vt-track-form] input[name="tracking_number"]')) return;
    if (input.getAttribute('aria-invalid') === 'true') setError(input.form, input, '');
  });

  window.VtTracking = { trackingUrl: trackingUrl, normalize: normalize };
})();